import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FolderOpen = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FolderOpen' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M5,2 L11,1.99999998 L13,6 L19,6 L19,10 L5,10 L5,2 Z M2,10 L22,10 L19,22 L5,22 L2,10 Z' />
  </StyledIcon>
);
